<div class="flex items-center gap-2">
  <ISelectMenu [value]="selectedMenuValue()" (valueChange)="selectPeriodComparison($event)" popoverWidth="320">
    <ISelectTrigger>
      <ISelectValue>
        <div *iSelectValue class="inline-flex flex-1 items-center justify-between gap-1 truncate">
          <span>{{ selectedOptionDisplay()?.label }}</span>
          <span class="type-label text-muted-foreground">{{ selectedOptionDisplay()?.formattedRange }}</span>
        </div>
      </ISelectValue>
    </ISelectTrigger>
    <ISelectContent>
      @for (o of comparisonPeriodOptions(); track o.value) {
        <ISelectOption [value]="o.value">
          <span class="inline-flex flex-1 items-center justify-between gap-1 truncate">
            <span>{{ o.label }}</span>
            <span class="type-label text-muted-foreground">{{ o.formattedRange }}</span>
          </span>
        </ISelectOption>
      }
    </ISelectContent>
  </ISelectMenu>
  @if (isSettingCustomComparison()) {
    <span>From : </span>
    <IDatePicker
      [dateFormat]="dateFormat()"
      [double]="false"
      [range]="false"
      [maxDate]="selectedDateRange().start"
      (selectedDateRangeChange)="selectCustomComparisonDate($event)"
    />
  }
</div>
